<template>
  <b-carousel
  v-editable="blok"
    style="text-shadow: 1px 1px 2px #333;"
    controls
    indicators
    :interval="400000"
    img-width="1024"
    img-height="200"
    class="slideshow"
    :fade="true"
  >
  <slideshow-slide :key="index" v-for="(slide,index) in blok.slides" :blok="slide"></slideshow-slide>
  </b-carousel>
</template>
<script>
import SlideshowSlide from "./SlideshowSlide.vue";

export default {
  name: "slideshow",
  props: ["blok"],
  components: {
    SlideshowSlide
  }
};
</script>